import { ProductReviewDetail } from 'api/products/_requests';
import axios from 'axios';
import { Product, ProductCat } from 'data/e-commerce/products';
import { handleRequest } from 'helpers/api';

const CATEGORIES_URL = `${process.env.REACT_APP_API_URL}/categories`;

const categoriesApi = axios.create({
  baseURL: CATEGORIES_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export interface Industry {
  _id: string;
  name: string;
}

export interface CategoryType {
  _id: string;
  name: string;
  slug: string;
  industry: string;
}

export interface Category {
  _id: string;
  name: string;
  type: string;
  industry: string;
  // slug: string;
}

export interface CategoryByCategoryType {
  categoryType?: string;
  total?: number;
  categories: Category[];
}

export interface SubCategory {
  _id: string;
  name: string;
  category: string;
  categoryType: string;
  industry: string;
}

export interface Brand {
  _id: string;
  image: string;
  name: string;
  slug: string;
}

export interface BrandPagination {
  docs: Brand[];
  totalDocs: number;
  limit: number;
  totalPages: number;
  page: number;
  pagingCounter: number;
  hasPrevPage: boolean;
  hasNextPage: boolean;
  prevPage: number;
  nextPage: number;
}

export interface Tag {
  _id: string;
  name: string;
  industry: string;
}

export interface BrandDetailSingle {
  _id: string;
  name: string;
  image: string;
  createdAt: string;
  email: string;
  phone: string;
  address: string;
  totalReview: number;
  totalRating: number;
  averageRating: number;
  totalRanking: number;
}

export interface BrandProducts {
  _id: string;
  slug: string;
  name: string;
  price: number;
  thumbnail: string;
}

export interface BrandResponse {
  brand: BrandDetailSingle;
  productCount: number;
}

export interface BrandReview {
  review: string;
  rating: number;
  brand: string;
}

export interface BrandReviewDetails {
  id?: string;
  review: string;
  rating: number;
  createdAt: string;
}

export interface BrandProductReviewList {
  productReviews: ProductReviewDetail[];
  brandReviews: BrandReviewDetails[];
}

export interface Subcategories {
  _id?: string;
  name?: string;
  slug?: string;
}

export interface Categories {
  _id?: string;
  name?: string;
  slug?: string;
  subcategories?: Subcategories[] | [];
}

export interface CategorySubCategory {
  _id?: string;
  name?: string;
  slug?: string;
  categories?: Categories[] | [];
}

export const getAllIndustries = async () => {
  return handleRequest(categoriesApi.get<Industry[]>('/industries'));
};

export const getAllCategoryTypes = async () => {
  return handleRequest(categoriesApi.get<CategoryType[]>('/category-types'));
};
export const getAllCategoryByCategoryTypes = async (slug?: string) => {
  if (!slug) throw new Error('typename is required');

  return handleRequest(
    categoriesApi.get<CategoryByCategoryType>(
      `/categories-by-categorytype?slug=${slug}`
    )
  );
};

export const getAllProductByCategoryType = async (slug: string) => {
  return handleRequest(
    categoriesApi.get<ProductCat[]>(`/products-by-categoryType/${slug}`)
  );
};

export const getAllCategoryTypesByIndustry = async (industryId: string) => {
  return handleRequest(
    categoriesApi.get<CategoryType[]>(`/category-types/industry/${industryId}`)
  );
};

export const getAllCategoriesByCategoryType = async (
  categoryTypeId: string
) => {
  return handleRequest(
    categoriesApi.get<Category[]>(`/categories/type/${categoryTypeId}`)
  );
};

export const getAllCategories = async () => {
  return handleRequest(categoriesApi.get<Category[]>('/categories'));
};

export const getAllSubCategoriesByCategory = async (categoryId: string) => {
  return handleRequest(
    categoriesApi.get<SubCategory[]>(`/sub-categories/category/${categoryId}`)
  );
};

export const getAllCategoriesSubCategoriesByCategoryType = async () => {
  return handleRequest(
    categoriesApi.get<CategorySubCategory[]>(`/categories-sub-categories`)
  );
};

export const getAllBrands = async () => {
  return handleRequest(categoriesApi.get<Brand[]>('/brands'));
};

export const getSubCategories = async () => {
  return handleRequest(categoriesApi.get<SubCategory[]>('/sub-categories'));
};

export const getBrandsByPagination = async (
  page: number,
  limit: number,
  search: string
) => {
  return handleRequest(
    categoriesApi.get<BrandPagination>(
      `/brands/pagination?page=${page}&limit=${limit}&search=${search}`
    )
  );
};

export const getAllTagsByIndustry = async (industryId: string) => {
  return handleRequest(
    categoriesApi.get<Tag[]>(`/tags/industry/${industryId}`)
  );
};

export const getProductsByBrand = async (brandSlug: string) => {
  return handleRequest(
    categoriesApi.get<BrandProducts[]>(`/products-by-brand/${brandSlug}`)
  );
};

export const getBrandProductReviewsByBrand = async (brandSlug: string) => {
  return handleRequest(
    categoriesApi.get<BrandProductReviewList>(
      `/brand-product-reviews-by-brand/${brandSlug}`
    )
  );
};
export const getBrandById = async (slug: string) => {
  return handleRequest(categoriesApi.get<BrandResponse>(`/brand/${slug}`));
};

export const addBrandReview = async (barndReview: BrandReview) => {
  return handleRequest(categoriesApi.post('/addBrandReview', barndReview));
};
